export default __webpack_public_path__ + "a48a8679692d2376cd5f1491232f4fac.png";